





import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { useLanguage } from '../context/LanguageContext';
import Logo from './Logo';
import { useNavigate } from 'react-router-dom';

const HERO_PAGES = ['home', 'about', 'gallery', 'committee', 'events', 'contact', 'darshan', 'location', 'donation', 'tenders', 'aaras-download', 'YadnyaBooking', 'MahaprasadBooking','privacy-policy'];

const Navbar = ({ currentPage, setCurrentPage }) => {
  const { t } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const hasHero = HERO_PAGES.includes(currentPage);



  // const navigate = useNavigate();

  // const handleNavClick = (pageId) => {
  //   navigate(`/${pageId}`);
  //   setIsMobileMenuOpen(false);
  // };



  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    setIsScrolled(window.scrollY > 60);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [currentPage]);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [currentPage]);

  const navItems = [
    { id: 'home',           label: t('nav.home') },
     { id: 'donation',       label: t('nav.donation') },
    { id: 'about',          label: t('nav.about') },
    { id: 'gallery',        label: t('nav.gallery') },
   
    { id: 'events',         label: t('nav.events') },
    { id: 'committee',      label: t('nav.committee') },
    { id: 'location',       label: t('nav.location') },
    { id: 'aaras-download', label: t('nav.download') },
    { id: 'tenders',        label: t('nav.tenders') },
    { id: 'contact',        label: t('nav.contact') },
//  { id: 'privacy-policy',        label: "Privcy-Policy" },

// { id: 'YadnyaBooking',        label: t('nav.YadnyaBooking') },
// { id: 'MahaprasadBooking',        label: t('nav.MahaprasadBooking') },

  ];

  // const handleNavClick = (pageId) => {
  //   setCurrentPage(pageId);
  //   setIsMobileMenuOpen(false);
  //   window.scrollTo({ top: 0, behavior: 'smooth' });
  // };

  const handleNavClick = (pageId) => {
  setCurrentPage(pageId);
  setIsMobileMenuOpen(false);
  window.scrollTo({ top: 0, behavior: 'smooth' });
  // ✅ हे add करा — URL बदलेल
  window.history.pushState({}, '', '/' + pageId);
};

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''} ${hasHero && !isScrolled ? 'navbar-transparent' : ''}`}>
      <div className="navbar-container">

        {/* Logo */}
        <div className="navbar-brand" onClick={() => handleNavClick('home')}>
          <Logo />
        </div>

        {/* Mobile: centered temple name */}
        <div
          className="navbar-mobile-title notranslate"
          translate="no"
          onClick={() => handleNavClick('home')}
        >
          <span className="title-decorator">॥</span>
          <span className="title-text">श्रीनाथ म्हस्कोबा महाराज</span>
          <span className="title-decorator">॥</span>
        </div>

        {/* Mobile: timings inside navbar below title */}
        <div className="navbar-mobile-timings">
          <span className="mob-timing-label">{t('home.darshanTimings')}</span>
          <div className="mob-timing-hours">
            <span>{t('home.morning')}</span>
            {/* <span className="mob-sep">|</span>
            <span>{t('home.evening')}</span> */}
          </div>
        </div>

        {/* Hamburger */}
        <button
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'open' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>

        {/* Desktop + Mobile Menu */}
        <ul className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          {navItems.map((item) => (
            <li key={item.id}>
              <button
                className={`nav-link ${currentPage === item.id ? 'active' : ''}`}
                onClick={() => handleNavClick(item.id)}
              >
                {item.label}
              </button>
            </li>
          ))}

          {/* Mobile: Donation button inside menu */}
          <li className="mobile-donation-item">
            <button
              className="nav-donate-btn"
              onClick={() => handleNavClick('donation')}
            >
              {t('donation.dontionbutton')}
            </button>
          </li>
        </ul>

        {/* Desktop actions */}
        <div className="navbar-actions">
          <button
            className="nav-donate-btn desktop-donate"
            onClick={() => handleNavClick('donation')}
          >
             {t('donation.dontionbutton')}
          </button>

          <div className="navbar-timings-desktop">
            <div className="nav-timing-item">
              <span className="timing-label">{t('home.darshanTimings')}:</span>
              <div className="nav-hours">
                <span>{t('home.morning')}</span>
                {/* <span className="separator">|</span> */}
                {/* <span>{t('home.evening')}</span> */}
              </div>
            </div>
          </div>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;